import _get from 'lodash/get';
import { diversityOptions } from '../AdvancedAwarenessPage/utils';

export function audienceLocationToString(audience) {
  if (audience) {
    const { zipCode, state, county, sector } = audience;

    if (state) {
      return state;
    }
    if (sector) {
      return sector;
    }
    if (county) {
      const { state: countyState, county: countyName } = county;
      return `${countyState} - ${countyName}`;
    }
    if (zipCode) {
      const { zipCode: value, radius } = zipCode;
      const withinText = (radius && radius > 0) ? ` - Within ${radius} Miles` : '';
      return `${value}${withinText}`;
    }
  }
  return '';
}

export function audienceToString(audience) {
  const diversityOption = diversityOptions.find(({ value }) => value === audience.diversity);
  const diversityText = _get(diversityOption, 'text', '');
  return `${audienceLocationToString(audience)} (${diversityText})`;
}

export function sortByName(a, b) {
  const auxA = a.name.toLowerCase();
  const auxB = b.name.toLowerCase();
  if (auxA < auxB) {
    return -1;
  }
  if (auxA > auxB) {
    return 1;
  }
  return 0;
}
